'use client';

import Image from 'next/image';

export default function Menu() {
  return (
    <div className="w-full py-16 sm:py-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Menu Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-foreground mb-3 sm:mb-4">
            Menu
          </h2>
          <p className="text-lg sm:text-xl text-foreground/70 font-medium">
            Fresh halal smash burgers, made to order. Every bite is Mo.
          </p>
        </div>

        {/* Full Menu Image */}
        <div className="w-full">
          <div className="relative w-full">
            <Image
              src="/images/uploads/409f8873-0708-4e0b-b018-c0b1b03c3c23.png"
              alt="Mo's Burger Full Menu"
              width={1200}
              height={1600}
              className="w-full h-auto object-contain rounded-2xl sm:rounded-3xl border-2 border-[#D71920]/20 shadow-md"
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 90vw, 1200px"
              priority
            />
          </div>
        </div>
      </div>
    </div>
  );
}
